import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import LinkBox from '../components/LinkBox';

export type PILegalRegistrationProps = {};

const PILegalRegistration: React.FC<PILegalRegistrationProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/electronics-rs.jpg'}
        heading={
          intl.formatMessage({
            id: 'public_info_7'
          })
        }
      />
      <div className="content">
        <div className="w-full flex flex-row flex-wrap justify-center">
          <div className="w-1/2 p-2">
            <LinkBox target='_blank' href="/pdf/legal/MCB-DAL-096 Requisitos Documentacion Legal.pdf" label={
              intl.formatMessage({
                id: 'list-req-legal'
              })
            } />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PILegalRegistration;